import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Lands here after Google sign-in: <origin>/account#session_id=... (rendered by App before normal routes)
export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const user = await exchangeGoogleSession(sessionId);
        window.history.replaceState(null, "", location.pathname);
        const next = sessionStorage.getItem("fl_google_next");
        sessionStorage.removeItem("fl_google_next");
        let dest = next && next.startsWith("/") ? next : "/account";
        if (user.role === "admin") dest = "/admin";
        else if (user.role === "florist") {
          const st = await axios.get(`${API}/onboarding/status`, { withCredentials: true }).then(r => r.data).catch(() => null);
          dest = st?.status === "in_progress" ? "/apri-negozio" : "/dashboard";
        }
        toast.success(`Ciao ${user.name?.split(" ")[0] || ""}, accesso effettuato`);
        navigate(dest, { replace: true, state: { user } });
      } catch (e) {
        setError(e.response?.data?.detail || "Accesso con Google non riuscito");
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream" data-testid="auth-callback">
      {error ? (
        <div className="text-center space-y-3">
          <p className="text-forest">{error}</p>
          <button onClick={() => navigate("/login", { replace: true })} className="text-brand underline text-sm" data-testid="auth-callback-retry">Torna all'accesso</button>
        </div>
      ) : (
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-forest" aria-label="Accesso in corso" />
      )}
    </div>
  );
};
